<template>
  <div
    ref="$el"
    class="small-call-to-action"
  >
    <UiComponentImage
      v-if="patternDesktop"
      alt="Pattern"
      class="pattern desktop"
      :expected-size="imageWidth"
      :height="imageHeight"
      :source="patternDesktop.url"
      :width="imageWidth"
    />
    <UiComponentImage
      v-if="patternMobile"
      alt="Pattern"
      class="pattern mobile"
      :expected-size="imageWidth"
      :height="imageHeight"
      :source="patternMobile.url"
      :width="imageWidth"
    />
    <div class="left">
      <UiComponentHeading
        as="paragraph"
        :level="4"
      >
        <slot name="heading" />
      </UiComponentHeading>
      <UiComponentParagraph><slot name="paragraph" /></UiComponentParagraph>
    </div>
    <div class="right">
      <AtomButton
        :action="callToAction.action"
        :label="callToAction.label"
        :to="callToAction.to"
        size="l"
        @click="emit('button:click', $event)"
      >
        {{ callToAction.slot }}
      </AtomButton>
    </div>
  </div>
</template>

<script setup>
// Emitter
const emit = defineEmits([
  'button:click',
])

// Props
const props = defineProps({
  callToAction: {
    required: true,
    type: Object,
  },
  patternDesktop: {
    default() {
      return undefined
    },
    required: false,
    type: Object,
  },
  patternMobile: {
    default() {
      return undefined
    },
    required: false,
    type: Object,
  },
})

// Refs
const $el = ref(null)
const imageHeight = ref(400)
const imageWidth = ref(1328)
const resizeObserver = ref(null)

// Methods
function onObserve() {
  imageHeight.value = $el.value.offsetHeight
  imageWidth.value = $el.value.offsetWidth
}

// Lifecycle Hooks
onBeforeUnmount(() => {
  resizeObserver.value.unobserve($el.value)
})

onMounted(() => {
  resizeObserver.value = new ResizeObserver(onObserve)
  resizeObserver.value.observe($el.value)
})
</script>

<style lang="postcss" scoped>
.small-call-to-action {
  @apply relative flex flex-col w-full h-auto p-8 bg-livestorm-blue-700 rounded-4xl;

  @screen md {
    @apply flex-row justify-between items-center p-10;
  }

  .pattern {
    @apply absolute inset-0 w-full h-full z-0 !important;

    &.desktop {
      @apply hidden;

      @screen md {
        @apply flex;
      }
    }

    &.mobile {
      @screen md {
        @apply hidden;
      }
    }
  }

  .left {
    @apply flex flex-col w-full z-10;

    @screen md {
      @apply max-w-sm;
    }

    .h4 {
      @apply font-medium text-white text-xl leading-7 !important;

      @screen mdminus {
        @apply text-2xl leading-8 !important;
      }

      @screen mdplus {
        @apply text-2xl leading-8 !important;
      }
    }

    .h4 + p {
      @apply mt-2 text-grey-blue-100 !important;
    }
  }

  .right {
    @apply flex flex-row w-full mt-8 z-10;

    @screen md {
      @apply mt-0 w-auto;
    }

    .button {
      &.primary {
        @apply bg-grey-blue-900;

        &:hover {
          @apply bg-black text-white;
        }
      }
    }
  }
}
</style>
